(function () {
  'use strict';

  const swiperEl = document.getElementById('bsb-lg-swiper');
  const overlay  = document.getElementById('bsb-lg-overlay');
  const lbClose  = document.getElementById('bsb-lg-close');

  if (!swiperEl) return;

  const swiperSpeed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;

  if (overlay) overlay.style.setProperty('--lg-overlay-opacity', overlay.dataset.overlayOpacity);

  const lgDataEl = document.getElementById('bsb-product-data');
  let lgVariants = [];
  let lgColorPos = null;
  let lgSizePos  = null;
  if (lgDataEl) {
    try {
      const lgData = JSON.parse(lgDataEl.textContent);
      lgVariants = lgData.variants || [];
      lgColorPos = lgData.colorPos != null ? lgData.colorPos + 1 : null;
      lgSizePos  = lgData.sizePos  != null ? lgData.sizePos  + 1 : null;
    } catch (err) {
      console.warn('[bsb-lg] Failed to parse product data island:', err);
    }
  }

  function updateCardImages(sizeValue) {
    if (lgColorPos == null || lgSizePos == null) return;

    swiperEl.querySelectorAll('.bsb-lg__card[data-lg-color]').forEach((card) => {
      const colorValue = card.getAttribute('data-lg-color');
      const match = lgVariants.find((v) => {
        return v['option' + lgColorPos] === colorValue && v['option' + lgSizePos] === sizeValue;
      });
      if (!match || !match.img400) return;

      const img = card.querySelector('.bsb-lg__img');
      if (img) {
        const nextSrcset = [400, 600, 900, 1200].map((w) => match['img' + w] + ' ' + w + 'w').join(', ');
        if (img.getAttribute('srcset') !== nextSrcset) {
          img.srcset = nextSrcset;
          img.src = match.img900;
        }
      }
      card.setAttribute('data-lg-img', match.img1200 || match.img900 || match.img400);
    });
  }

  document.addEventListener('change', (e) => {
    if (e.target.name === 'bsb-size') updateCardImages(e.target.value);
  });

  const syncAvailability = () => {
    swiperEl.querySelectorAll('.bsb-lg__btn').forEach((btn) => {
      const radio = document.querySelector('input[name="bsb-color"][value="' + CSS.escape(btn.getAttribute('data-lg-color')) + '"]');
      btn.classList.toggle('bsb-lg__btn--unavailable', !!(radio && radio.disabled));
    });
  };

  let swiper = null;

  const PRELOAD_AHEAD = 6;

  const loadAhead = (s) => {
    s.slides.slice(s.activeIndex, s.activeIndex + PRELOAD_AHEAD).forEach((slide) => {
      const img = slide.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    });
  };

  function initSwiper() {
    if (typeof Swiper === 'undefined') return;
    const prevEl = document.getElementById('bsb-lg-arrow-prev');
    const nextEl = document.getElementById('bsb-lg-arrow-next');

    function setLocked(locked) {
      prevEl && prevEl.classList.toggle('bsb-lg__arrow--hidden', locked);
      nextEl && nextEl.classList.toggle('bsb-lg__arrow--hidden', locked);
    }

    swiper = new Swiper('#bsb-lg-swiper', {
      speed: swiperSpeed,
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      threshold: 5,
      slideToClickedSlide: false,
      navigation: {
        prevEl: '#bsb-lg-arrow-prev',
        nextEl: '#bsb-lg-arrow-next',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        init(s)        { setLocked(s.isLocked); loadAhead(s); },
        slideChange(s) { loadAhead(s); },
        lock(s)   { setLocked(true); },
        unlock(s) { setLocked(false); },
      },
    });
  }

  function setActiveCard(colorName) {
    swiperEl.querySelectorAll('.bsb-lg__card').forEach((card) => {
      const isMatch = card.getAttribute('data-lg-color') === colorName;
      card.toggleAttribute('aria-current', isMatch);
    });
  }

  window.bsbLgSyncColor = (colorName) => setActiveCard(colorName);

  let lightboxSwiper = null;
  let lbTriggerEl     = null;

  const readSlide = (el) => ({
    src: el.getAttribute('data-lg-img') || '',
    alt: el.getAttribute('data-lg-alt') || '',
  });

  const getCards = () => Array.from(swiperEl.querySelectorAll('.bsb-lg__card'));

  const checkedValue = (name) => {
    const input = document.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : null;
  };

  const variantSlides = (source, productTitle) => {
    const color = checkedValue('bsb-color');
    const size = checkedValue('bsb-size');
    const seen = new Set();
    return lgVariants
      .filter((v) => {
        if (source === 'variant_color' && lgColorPos != null && v['option' + lgColorPos] !== color) return false;
        if (source === 'variant_size' && lgSizePos != null && v['option' + lgSizePos] !== size) return false;
        return true;
      })
      .map((v) => ({
        src: v.img1200 || v.img900 || v.img400,
        alt: [productTitle, v['option' + lgColorPos], v['option' + lgSizePos]].filter(Boolean).join(' — '),
      }))
      .filter((slide) => slide.src && !seen.has(slide.src) && seen.add(slide.src));
  };

  const getAllImageSlides = () => {
    const wrap = document.getElementById('bsb-lg-all-images');
    if (!wrap) return [];
    const source = wrap.getAttribute('data-lg-source');
    if (source) return variantSlides(source, wrap.getAttribute('data-lg-title'));
    return Array.from(wrap.querySelectorAll('.bsb-lg__all-item')).map(readSlide);
  };

  function buildLightboxSlides(slides, startIndex) {
    const wrapper = document.getElementById('bsb-lg-lightbox-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = '';
    slides.forEach(({ src, alt }, i) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      const zoom = document.createElement('div');
      zoom.className = 'swiper-zoom-container';
      const img = document.createElement('img');
      img.className = 'bsb-lg__lightbox-img';
      img.loading = i === startIndex ? 'eager' : 'lazy';
      img.src = src;
      img.alt = alt;
      zoom.appendChild(img);
      slide.appendChild(zoom);
      wrapper.appendChild(slide);
    });
  }

  window.bsbOpenLightbox = function (index, slides, triggerEl) {
    openLightbox(index, slides, triggerEl);
  };

  function openLightbox(index, slides, triggerEl) {
    const cards = getCards();
    const items = slides || cards.map(readSlide);
    if (!items.length || !overlay || typeof Swiper === 'undefined') return;
    lbTriggerEl = triggerEl || cards[index] || null;

    buildLightboxSlides(items, index);

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (lightboxSwiper) {
      lightboxSwiper.destroy(true, true);
      lightboxSwiper = null;
    }

    lightboxSwiper = new Swiper('#bsb-lg-lightbox-swiper', {
      initialSlide: index,
      speed: swiperSpeed,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      threshold: 5,
      slideToClickedSlide: false,
      navigation: {
        prevEl: '#bsb-lg-prev',
        nextEl: '#bsb-lg-next',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next',
      },
      zoom: {
        maxRatio: 3,
        toggle: false,
      },
      on: {
        slideChange: function (sw) {
          sw.zoom.out();
        },
        zoomChange: function (sw, scale) {
          overlay.classList.toggle('is-zoomed', scale > 1);
        },
      },
    });

    if (lbClose) lbClose.focus();
  }

  if (overlay) {
    let pressX = 0;
    let pressY = 0;

    overlay.addEventListener('pointerdown', (e) => {
      pressX = e.clientX;
      pressY = e.clientY;
    });

    overlay.addEventListener('click', (e) => {
      const img = e.target.closest('.bsb-lg__lightbox-img');
      if (!img) return;
      if (!lightboxSwiper || !lightboxSwiper.zoom) return;
      const moved =
        Math.abs(e.clientX - pressX) > 5 || Math.abs(e.clientY - pressY) > 5;
      if (moved) return;
      e.preventDefault();
      lightboxSwiper.zoom.toggle(e);
    });
  }

  function closeLightbox() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lightboxSwiper) {
      lightboxSwiper.destroy(true, true);
      lightboxSwiper = null;
    }
    const wrapper = document.getElementById('bsb-lg-lightbox-wrapper');
    if (wrapper) wrapper.innerHTML = '';
    if (lbTriggerEl) lbTriggerEl.focus();
  }

  function navLightbox(dir) {
    if (!lightboxSwiper) return;
    if (dir < 0) lightboxSwiper.slidePrev();
    else lightboxSwiper.slideNext();
  }

  swiperEl.addEventListener('click', (e) => {
    const btn = e.target.closest('.bsb-lg__btn');
    if (btn) {
      e.stopPropagation();
      const colorName = btn.getAttribute('data-lg-color');
      if (!colorName) return;

      const radio = document.querySelector(
        'input[name="bsb-color"][value="' + CSS.escape(colorName) + '"]'
      );
      if (radio && !radio.disabled) {
        setActiveCard(colorName);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const card = e.target.closest('.bsb-lg__card');
    if (card) {
      const index = parseInt(card.getAttribute('data-lg-index'), 10);
      if (!Number.isNaN(index)) openLightbox(index);
    }
  });

  if (overlay)  overlay.addEventListener('click',  (e) => { if (e.target === overlay) closeLightbox(); });
  if (lbClose)  lbClose.addEventListener('click',  closeLightbox);

  const viewAllBtn = document.getElementById('bsb-lg-view-all');
  if (viewAllBtn) {
    viewAllBtn.addEventListener('click', () => {
      openLightbox(0, getAllImageSlides(), viewAllBtn);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape')     { e.preventDefault(); closeLightbox(); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); navLightbox(-1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); navLightbox(1); }
  });

  if (overlay) {
    overlay.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = Array.from(overlay.querySelectorAll('button'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  syncAvailability();

  if (typeof Swiper !== 'undefined') {
    initSwiper();
  } else {
    document.addEventListener('DOMContentLoaded', initSwiper);
  }

})();